// extracted by mini-css-extract-plugin
export default {"container":"zO-z","modal":"AO-z","dimensions":"BO-z","brandName":"CO-z","productName":"DO-z","labelValue":"EO-z","recipientEmail":"FO-z","recommendedFit":"GO-z","hiddenField":"HO-z"};